/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const JwtAccessTokenExpiresSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('JWT_ACCESS_TOKEN_EXPIRES')],
    ['value', /* #__PURE__ */ parsers.maybeNull(parsers.duration)],
]);
export class JwtAccessTokenExpiresSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return JwtAccessTokenExpiresSettingParser.decode(input).map(res => new JwtAccessTokenExpiresSetting(res));
    }
    static unsafeDecode(input) {
        return JwtAccessTokenExpiresSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return JwtAccessTokenExpiresSettingParser.encode(data);
    }
    static schema() {
        return JwtAccessTokenExpiresSettingParser.schema();
    }
}
